import { imageNames } from "@/src/constants/imageConstants.js";
import { pluralFeatureNames } from "@/src/constants/globalConstants";
import DealAnalytics from "@/src/views/analytics/v2/deal_analytics/DealAnalytics.vue";
import CallAnalytics from "@/src/views/analytics/v2/call_analytics/CallAnalytics.vue";
import MeetingAnalytics from "@/src/views/meetings/meeting_agent/MeetingAnalytics.vue";
import SequenceAnalytics from "@/src/views/analytics/v2/sequence_analytics/SequenceAnalytics.vue";
import ProspectingAnalytics from "@/src/views/analytics/v2/prospecting_analytics/ProspectingAnalytics.vue";
import SuperAGIActivityAnalytics from "@/src/views/analytics/v2/superagi_activity_analytics/SuperAGIActivityAnalytics.vue";
import MarketingCampaignsAnalytics from "@/src/views/analytics/v2/marketing_campaign_analytics/MarketingCampaignsAnalytics.vue";

export const analyticsUserTypes = {
  USER: "user",
  SUPERAGI: "superagi",
};

export const analyticTypes = {
  CHART: "chart",
  TABLE: "table",
};

export const analyticActions = {
  CREATED: "created",
  COUNT: "count",
  MARKET_RESEARCH: "market_research",
};

export const dealConversionTypes = {
  COUNT: "count",
  AMOUNT: "amount",
};

export const bookingOrderTypes = {
  ASC: "asc",
  DESC: "desc",
};

export const emailCountActions = {
  EMAIL_SENT: "email_sent",
  EMAIL_REPLIED: "email_replied",
  EMAIL_POSITIVE_REPLIED: "email_positive_replied",
  EMAIL_BOUNCED: "email_bounced",
  EMAIL_REPLIED_RATE: "email_replied_rate",
  EMAIL_POSITIVE_REPLIED_RATE: "email_positive_replied_rate",
};

export const linkedinCountActions = {
  CONNECTION_SENT: "connection_sent",
  INMAIL_SENT: "inmail_sent",
  MESSAGE_SENT: "message_sent",
  INMAIL_REPLIED: "inmail_replied",
  MESSAGE_REPLIED: "message_replied",
};

export const callEngagementTableHeaders = [
  { label: "User Name", key: "user_name", width: 3 },
  { label: "Calls Dialed", key: "calls_dialed", width: 3 },
  { label: "Calls Connected", key: "calls_connected", width: 3 },
  {
    label: "Average Call Duration(sec)",
    key: "avg_call_connected_duration",
    width: 3,
  },
];

export const emailEngagementTableHeaders = [
  { label: "Campaign Name", key: "campaign_name", width: 3 },
  { label: "Emails Sent", key: "emails_sent", width: 3 },
  { label: "Email Opens", key: "emails_opened", width: 3 },
  { label: "Email Clicks", key: "emails_clicked", width: 3 },
  { label: "Emails Delivered", key: "emails_delivered", width: 3 },
  { label: "Emails Bounced", key: "emails_bounced", width: 3 },
];

export const whatsappEngagementTableHeaders = [
  { label: "Campaign Name", key: "campaign_name", width: 3 },
  { label: "WhatsApp Sent", key: "whatsapp_sent", width: 3 },
  { label: "WhatsApp Clicked", key: "whatsapp_clicked", width: 3 },
  { label: "WhatsApp Replied", key: "whatsapp_replied", width: 3 },
  { label: "WhatsApp Delivered", key: "whatsapp_delivered", width: 3 },
  { label: "WhatsApp Bounced", key: "whatsapp_bounced", width: 3 },
];

export const salesActivityTableHeaders = [
  { label: "User Name", key: "user_name", width: 2 },
  { label: "Email Sent", key: "emails_sent", width: 2 },
  { label: "Calls Done", key: "calls_done", width: 2 },
  { label: "LinkedIn Messages Sent", key: "linkedin_messages_sent", width: 2 },
  { label: "LinkedIn InMails Sent", key: "linkedin_inmails_sent", width: 2 },
  {
    label: "LinkedIn Connection Requests",
    key: "linkedin_connection_requests",
    width: 2,
  },
];

export const emailCampaignsPerformanceTableHeaders = [
  { label: "Campaign Name", key: "campaign_name", width: 2 },
  { label: "Emails Sent", key: "emails_sent", width: 2 },
  { label: "Opened", key: "open_count", width: 2 },
  { label: "Clicked", key: "click_count", width: 2 },
  { label: "Replied", key: "reply_count", width: 2 },
  { label: "Positive Replies", key: "positive_reply_count", width: 2 },
];

export const topMeetingAgentsTableHeaders = [
  { label: "Meeting Agent Name", key: "agent_name", width: 6 },
  { label: "Meetings booked", key: "count", width: 6 },
];

export const meetingAnalyticsTableHeaders = [
  { label: "Member Name", key: "user_name", width: 3, view: true },
  { label: "Created", key: "meeting_created", width: 3 },
  { label: "Completed", key: "meeting_completed", width: 3 },
  { label: "Cancelled", key: "meeting_canceled", width: 3 },
];

export const units = {
  SECOND: { single: "sec", plural: "secs" },
  MINUTE: { single: "min", plural: "mins" },
  HOUR: { single: "hr", plural: "hrs" },
  DAY: { single: "day", plural: "days" },
  MONTH: { single: "month", plural: "months" },
  YEAR: { single: "year", plural: "years" },
  RATE: { suffix: "%" },
  AMOUNT: { prefix: "$" },
};

export const analyticsAllTabs = [
  {
    title: "Prospecting & Sales Development",
    component: ProspectingAnalytics,
    id: "prospecting_analytics",
  },
  {
    title: "Cold Outreach",
    component: SuperAGIActivityAnalytics,
    id: "superagi_activity_analytics",
  },
  {
    title: "Deals",
    component: DealAnalytics,
    id: "deals_analytics",
  },
  {
    title: "Calls",
    component: CallAnalytics,
    id: "call_analytics",
  },
  {
    title: "Meetings",
    component: MeetingAnalytics,
    id: "meeting_analytics",
  },
  {
    title: `${pluralFeatureNames.SEQUENCES}`,
    component: SequenceAnalytics,
    id: "sequence_analytics",
  },
  {
    title: "Marketing Campaigns",
    component: MarketingCampaignsAnalytics,
    id: "marketing_campaigns_analytics",
  },
];

export const analyticsFilterEntity = {
  USER: "user",
  TEAM: "team",
  PEOPLE: "people",
  PIPELINE: "pipeline",
  MAILBOX: "mailbox",
  SEQUENCE: "sequence",
  MEETING_AGENT: "meeting_agent",
  ROUTING_FORM: "routing_form",
  CHANNEL_TYPE: "channel_type",
};

export const channelTypeOptions = [
  { id: "email", name: "Email" },
  { id: "sms", name: "SMS" },
  { id: "whatsapp", name: "WhatsApp" },
];

export const superAGIAllowedFilters = [];

export const prospectingAllowedFilters = [
  analyticsFilterEntity.USER,
  analyticsFilterEntity.TEAM,
];

export const dealsAllowedFilters = [
  analyticsFilterEntity.USER,
  analyticsFilterEntity.TEAM,
  analyticsFilterEntity.PIPELINE,
];

export const callsAllowedFilters = [
  analyticsFilterEntity.USER,
  analyticsFilterEntity.TEAM,
];

export const meetingsAllowedFilters = [
  analyticsFilterEntity.USER,
  analyticsFilterEntity.TEAM,
  analyticsFilterEntity.MEETING_AGENT,
];

export const sequenceAllowedFilters = [
  analyticsFilterEntity.SEQUENCE,
  analyticsFilterEntity.USER,
  analyticsFilterEntity.TEAM,
];

export const routingFormsAllowedFilters = [analyticsFilterEntity.ROUTING_FORM];

export const marketingCampaignsAllowedFilters = [
  analyticsFilterEntity.CHANNEL_TYPE,
];

export const multiSelectFilters = [
  analyticsFilterEntity.USER,
  analyticsFilterEntity.TEAM,
];

export const sequenceActions = {
  TOTAL_PEOPLE: "TOTAL_PEOPLE",
  TOTAL_CONTACTS: "TOTAL_CONTACTS",
  TOTAL_LEADS: "TOTAL_LEADS",
  EMAIL_OPEN_RATE: "EMAIL_OPEN_RATE",
  EMAIL_CLICK_RATE: "EMAIL_CLICK_RATE",
  EMAIL_REPLY_RATE: "EMAIL_REPLY_RATE",
  LINKEDIN_ACCEPTANCE_RATE: "LINKEDIN_ACCEPTANCE_RATE",
  LINKEDIN_REPLY_RATE: "LINKEDIN_REPLY_RATE",
};

export const marketingActions = {
  TOTAL_CAMPAIGNS_SENT: "TOTAL_CAMPAIGNS_SENT",
  TOTAL_EMAIL_CAMPAIGNS_SENT: "TOTAL_EMAIL_CAMPAIGNS_SENT",
  // TOTAL_SMS_CAMPAIGNS_SENT: "TOTAL_SMS_CAMPAIGNS_SENT",
  TOTAL_WHATSAPP_CAMPAIGNS_SENT: "TOTAL_WHATSAPP_CAMPAIGNS_SENT",
};

export const marketingAnalyticsDataStructure = [
  {
    id: marketingActions.TOTAL_CAMPAIGNS_SENT,
    title: "Total Campaigns Sent",
    value: 0,
    isLoading: false,
  },
  {
    id: marketingActions.TOTAL_EMAIL_CAMPAIGNS_SENT,
    title: "Total Email Campaigns Sent",
    value: 0,
    isLoading: false,
  },
  {
    id: marketingActions.TOTAL_WHATSAPP_CAMPAIGNS_SENT,
    title: "Total WhatsApp campaigns sent",
    value: 0,
    isLoading: false,
  },
];

export const sequenceEmailActions = {
  EMAIL_SENT: "EMAIL_SENT",
  EMAIL_OPENED: "EMAIL_OPENED",
  EMAIL_CLICKED: "EMAIL_CLICKED",
  EMAIL_REPLIED: "EMAIL_REPLIED",
  EMAIL_POSITIVE_REPLIES: "EMAIL_POSITIVE_REPLIES",
  EMAIL_OOO_REPLIES: "EMAIL_OOO_REPLIES",
  EMAIL_SKIPPED: "EMAIL_SKIPPED",
  EMAIL_BOUNCED: "EMAIL_BOUNCED",
  EMAIL_UNSUBSCRIBED: "EMAIL_UNSUBSCRIBED",
};

export const marketingEmailActions = {
  EMAIL_SENT: "EMAIL_SENT",
  EMAIL_OPENED: "EMAIL_OPENED",
  EMAIL_CLICKED: "EMAIL_CLICKED",
  EMAIL_REPLIED: "EMAIL_REPLIED",
  EMAIL_POSITIVE_REPLIES: "EMAIL_POSITIVE_REPLIES",
  EMAIL_BOUNCED: "EMAIL_BOUNCED",
  TOTAL_DELIVERED: "TOTAL_DELIVERED",
  TOTAL_UNSUBSCRIBED: "TOTAL_UNSUBSCRIBED",
  DELIVERY_RATE: "DELIVERY_RATE",
  OPEN_RATE: "OPEN_RATE",
  CLICK_RATE: "CLICK_RATE",
};

export const sequenceWhatsappActions = {
  WHATSAPP_SENT: "WHATSAPP_SENT",
  WHATSAPP_CLICKED: "WHATSAPP_CLICKED",
  WHATSAPP_REPLIED: "WHATSAPP_REPLIED",
  WHATSAPP_BOUNCED: "WHATSAPP_BOUNCED",
  WHATSAPP_UNSUBSCRIBED: "WHATSAPP_UNSUBSCRIBED",
};

export const marketingWhatsappActions = {
  WHATSAPP_SENT: "WHATSAPP_SENT",
  WHATSAPP_CLICKED: "WHATSAPP_CLICKED",
  WHATSAPP_REPLIED: "WHATSAPP_REPLIED",
  WHATSAPP_BOUNCED: "WHATSAPP_BOUNCED",
  WHATSAPP_UNSUBSCRIBED: "WHATSAPP_UNSUBSCRIBED",
};

export const sequenceLinkedinActions = {
  LINKEDIN_INVITE: "LINKEDIN_INVITE",
  LINKEDIN_INVITE_ACCEPTED: "LINKEDIN_INVITE_ACCEPTED",
  LINKEDIN_INMAIL: "LINKEDIN_INMAIL",
  LINKEDIN_INMAIL_REPLIES: "LINKEDIN_INMAIL_REPLIES",
  LINKEDIN_MESSAGE: "LINKEDIN_MESSAGE",
  LINKEDIN_MESSAGE_REPLIES: "LINKEDIN_MESSAGE_REPLIES",
  LINKEDIN_SKIPPED: "LINKEDIN_SKIPPED",
};

export const sequenceTaskActions = {
  TASK_CREATED: "TASK_CREATED",
  TASK_PENDING: "TASK_PENDING",
  TASK_COMPLETED: "TASK_COMPLETED",
  TASK_OVERDUE: "TASK_OVERDUE",
};

export const marketingEmailFunnelStages = [
  { label: "Sent", key: "sent" },
  { label: "Opened", key: "opened" },
  { label: "Clicked", key: "clicked" },
  { label: "Bounced", key: "bounced" },
  { label: "Unsubscribed", key: "unsubscribed" },
];

export const marketingWhatsappFunnelStages = [
  { label: "Sent", key: "sent" },
  { label: "Delivered", key: "delivered" },
  { label: "Clicked", key: "clicked" },
  { label: "Replied", key: "replied" },
  { label: "Bounced", key: "bounced" },
  { label: "Unsubscribed", key: "unsubscribed" },
];

export const SequenceEmailAnalyticsData = [
  {
    id: sequenceEmailActions.EMAIL_SENT,
    title: "Emails sent",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_OPENED,
    title: "Email opens",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_CLICKED,
    title: "Email clicks",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_REPLIED,
    title: "Emails replied",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_POSITIVE_REPLIES,
    title: "Positive replies",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_OOO_REPLIES,
    title: "Out of office replies",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_SKIPPED,
    title: "Skipped",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceEmailActions.EMAIL_BOUNCED,
    title: "Percentage of bounced emails",
    value: 0,
    isLoading: false,
    unit: units.RATE,
  },
];

export const SequenceWhatsappAnalyticsData = [
  {
    id: sequenceWhatsappActions.WHATSAPP_SENT,
    title: "WhatsApp sent",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceWhatsappActions.WHATSAPP_CLICKED,
    title: "WhatsApp clicked",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceWhatsappActions.WHATSAPP_REPLIED,
    title: "WhatsApp replied",
    value: 0,
    isLoading: false,
  },
  {
    id: sequenceWhatsappActions.WHATSAPP_BOUNCED,
    title: "Percentage of bounced WhatsApp",
    value: 0,
    isLoading: false,
    unit: units.RATE,
  },
  {
    id: sequenceWhatsappActions.WHATSAPP_UNSUBSCRIBED,
    title: "Percentage of unscuscribed WhatsApp",
    value: 0,
    isLoading: false,
    unit: units.RATE,
  },
];

export const ANALYTICS_REFRESH_INTERVAL = 60000;

export const analyticsChatEntityType = {
  USER: "user",
  LLM: "llm",
};

export const analyticsDashboardStatuses = {
  DRAFT: "draft",
  PUBLISHED: "published",
};

export const analyticsDashboardStatusesConfig = {
  [analyticsDashboardStatuses.DRAFT]: {
    buttonText: {
      default: "Publish",
      loading: "Publishing..",
    },
    nextStatus: analyticsDashboardStatuses.PUBLISHED,
    successMessage: "Dashboard published successfully!",
  },
  [analyticsDashboardStatuses.PUBLISHED]: {
    buttonText: {
      default: "Save changes",
      loading: "Saving..",
    },
    nextStatus: analyticsDashboardStatuses.PUBLISHED,
    successMessage: "Changes saved successfully!",
  },
};

export const analyticsDashboardActions = {
  SAVE_AS_NEW_DASHBOARD: "save_as_new_dashboard",
  DISCARD_CHANGES: "discard_changes",
};

export const analyticsDashboardActionDetails = [
  {
    id: analyticsDashboardActions.SAVE_AS_NEW_DASHBOARD,
    label: "Save as new dashboard",
    icon: imageNames.PANEL_ANALYTICS,
    handler: "handleSaveAsNewDashboard",
  },
  {
    id: analyticsDashboardActions.DISCARD_CHANGES,
    label: "Discard changes",
    icon: imageNames.NOT_ALLOWED_GREY,
    handler: "handleDiscardChanges",
  },
];

export const analyticsHeaderActions = {
  EDIT_DASHBOARD: "edit_dashboard",
  EXPORT_AS_CSV: "export_as_csv",
};

export const analyticsHeaderActionOptions = [
  {
    id: analyticsHeaderActions.EDIT_DASHBOARD,
    label: "Edit",
    icon: imageNames.EDIT,
    handler: null,
  },
  {
    id: analyticsHeaderActions.EXPORT_AS_CSV,
    label: "Export as CSV",
    icon: imageNames.EXPORT_GREY,
    handler: null,
  },
];

export const dashboardEvents = {
  CREATED: "created",
  UPDATED: "updated",
  DELETED: "deleted",
};

export const getDashboardItemActions = (imageNames, handlers) => [
  {
    id: "more_options",
    title: "More options",
    icon: imageNames.MORE_ICON_GREY,
    size: 14,
    tooltip: true,
    options: [
      {
        id: "rename",
        title: "Rename",
        icon: imageNames.EDIT,
        size: 14,
        action: handlers.onRename,
      },
      {
        id: "open_new_tab",
        title: "Open in new tab",
        icon: imageNames.ARROW_OUTWARD,
        size: 14,
        action: handlers.onOpenInNewTab,
      },
      {
        id: "delete",
        title: "Delete",
        icon: imageNames.DELETE_GREY,
        size: 14,
        action: handlers.onDelete,
      },
    ],
  },
];

export const analyticsEditorTypes = {
  AI: "ai",
  MANUAL: "manual",
  SQL: "sql",
};

const baseAnalyticsEditorTypeOptions = [
  {
    id: analyticsEditorTypes.AI,
    title: "Generate with AI",
    description: "Let AI build your analytics automatically",
    icon: imageNames.SUPER_AGI_HOLLOW_BOLT,
    size: 26,
  },
  {
    id: analyticsEditorTypes.MANUAL,
    title: "Create manually",
    description: "Build analytics using visual interface",
    icon: imageNames.MANUAL_ANALYTICS,
    size: 22,
  },
  {
    id: analyticsEditorTypes.SQL,
    title: "Create with SQL",
    description: "Write custom SQL queries for data",
    icon: imageNames.SQL_ANALYTICS,
    size: 24,
  },
];

export const getAnalyticsEditorTypeOptions = () => {
  try {
    const hasSqlAnalytics = localStorage.getItem("sql_analytics");

    if (hasSqlAnalytics) {
      return baseAnalyticsEditorTypeOptions;
    }

    return baseAnalyticsEditorTypeOptions?.filter(
      (option) => option.id !== analyticsEditorTypes.SQL,
    );
  } catch (error) {
    console.error(
      "An error occurred while getting analytics editor type options: ",
      error,
    );
    return baseAnalyticsEditorTypeOptions;
  }
};

export const analyticsEditorTypeOptions = getAnalyticsEditorTypeOptions();

export const analyticsCharts = {
  HORIZONTAL: "horizontal_chart",
  VERTICAL: "vertical_chart",
  AREA: "area_chart",
  GAUGE: "gauge_chart",
  KPI: "kpi_chart",
  LINE: "line_chart",
  PIE: "pie_chart",
  SCATTER: "scatter_chart",
  TABLE: "table_chart",
  DONUT: "donut_chart",
  PIVOT_TABLE: "pivot_table_chart",
  FUNNEL: "funnel_chart",
};

export const analyticsChartOptions = [
  {
    id: analyticsCharts.VERTICAL,
    title: "Vertical Bar Chart",
    description: "Compare values across categories vertically",
    icon: imageNames.VERTICAL_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.HORIZONTAL,
    title: "Horizontal Bar Chart",
    description: "Compare values across categories horizontally",
    icon: imageNames.HORIZONTAL_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.LINE,
    title: "Line Chart",
    description: "Track changes and trends over time",
    icon: imageNames.LINE_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.SCATTER,
    title: "Scatter Chart",
    description: "Visualize correlation between two variables",
    icon: imageNames.SCATTER_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.PIE,
    title: "Pie Chart",
    description: "Show parts of a whole as percentages",
    icon: imageNames.PIE_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.DONUT,
    title: "Donut Chart",
    description: "Show parts of a whole as percentages",
    icon: imageNames.DONUT_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.KPI,
    title: "KPI Chart",
    description: "Highlight key performance metrics",
    icon: imageNames.KPI_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.TABLE,
    title: "Table Chart",
    description: "Display detailed data in rows and columns",
    icon: imageNames.TABLE_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.GAUGE,
    title: "Gauge Chart",
    description: "Display single value against a target range",
    icon: imageNames.GAUGE_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.AREA,
    title: "Area Chart",
    description: "Show trends and cumulative values over time",
    icon: imageNames.AREA_CHART,
    size: 20,
  },
  {
    id: analyticsCharts.PIVOT_TABLE,
    title: "Pivot Table",
    description: "Summarize data with multi-dimensional grouping",
    icon: imageNames.PIVOT_TABLE,
    size: 20,
  },
  {
    id: analyticsCharts.FUNNEL,
    title: "Funnel Chart",
    description: "Track conversion rates through sequential stages",
    icon: imageNames.FUNNEL_CHART,
    size: 20,
  },
];

export const chartFieldTypes = {
  MEASURE: "measure",
  DIMENSION: "dimension",
  DATE: "date",
};

export const measureDataTypes = [
  "number",
  "integer",
  "decimal",
  "float",
  "currency",
];

export const dimensionDataTypes = [
  "date",
  "datetime",
  "timestamp",
  "boolean",
  "select",
  "dropdown",
  "enum",
  "text",
  "string",
  "rich_text",
  "owner",
  "user",
  "lookup",
  "id",
  "uuid",
];

export const dateDataTypes = ["date", "datetime", "timestamp"];

export const selectDataTypes = ["select", "dropdown", "enum"];

export const multiSelectDataTypes = ["multi_select", "multiselect"];

export const userDataTypes = ["user", "owner"];

export const booleanDataTypes = ["boolean"];

// Properties that support server-side search in analytics filter dropdowns.
export const remoteSearchPropertyConfig = {
  company: {
    slugs: ["current_company", "company", "current_company_id"],
    searchFn: "searchCompanies",
  },
};

export const stringDataTypes = [
  "text",
  "string",
  "rich_text",
  "select",
  "dropdown",
  "enum",
  "owner",
  "user",
  "lookup",
  "url",
  "email",
  "phone_number",
  "domain",
  "textarea",
  "multi_select",
  "multiselect",
];

export const configDataTypeCategories = {
  NUMBER: "number",
  DATE: "date",
  BOOLEAN: "boolean",
  STRING: "string",
  OTHER: "other",
};

export const aggregationOptions = [
  { id: "count", label: "Count" },
  { id: "sum", label: "Sum" },
  { id: "avg", label: "Avg" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
];

export const frequencyOptions = [
  { id: "daily", label: "Daily" },
  { id: "weekly", label: "Weekly" },
  { id: "monthly", label: "Monthly" },
  { id: "quarterly", label: "Quarterly" },
  { id: "yearly", label: "Yearly" },
];

export const numberAggregationOptions = [
  { id: "count", label: "Count" },
  { id: "count_distinct", label: "Count (Distinct)" },
  { id: "sum", label: "Sum" },
  { id: "avg", label: "Avg" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
  { id: "median", label: "Median" },
  { id: "cumulative_sum", label: "Cumulative Sum" },
  { id: "cumulative_count", label: "Cumulative Count" },
];

export const dateAggregationOptions = [
  { id: "hourly", label: "Hourly" },
  { id: "daily", label: "Daily" },
  { id: "weekly", label: "Weekly" },
  { id: "monthly", label: "Monthly" },
  { id: "quarterly", label: "Quarterly" },
  { id: "yearly", label: "Yearly" },
];

export const booleanAggregationOptions = [
  { id: "count", label: "Count" },
];

export const dateValueAggregationOptions = [
  { id: "count_distinct", label: "Count (Distinct)" },
  { id: "count", label: "Count" },
  { id: "min", label: "Min" },
  { id: "max", label: "Max" },
  { id: "median", label: "Median" },
];

export const stringAggregationOptions = [
  { id: "count_distinct", label: "Count (Distinct)" },
  { id: "count", label: "Count" },
];

export const dimensionAggregationOptions = [
  { id: "none", label: "None" },
  { id: "count", label: "Count" },
  { id: "count_distinct", label: "Count (Distinct)" },
];

export const numberGroupOptions = [
  { id: "auto", label: "Auto Grouped" },
  { id: "2", label: "2" },
  { id: "5", label: "5" },
  { id: "10", label: "10" },
  { id: "20", label: "20" },
  { id: "50", label: "50" },
  { id: "100", label: "100" },
  { id: "ungrouped", label: "Ungrouped" },
];

export const dateGroupOptions = [
  { id: "auto", label: "Auto Grouped" },
  { id: "hour", label: "Hour" },
  { id: "day", label: "Day" },
  { id: "week", label: "Week" },
  { id: "month", label: "Month" },
  { id: "quarter", label: "Quarter" },
  { id: "year", label: "Year" },
  { id: "day_of_week", label: "Day of Week" },
  { id: "month_of_year", label: "Month of Year" },
  { id: "ungrouped", label: "Ungrouped" },
];

export const sortOptions = [
  { id: "none", label: "None" },
  { id: "asc", label: "Ascending" },
  { id: "desc", label: "Descending" },
  { id: "value_asc", label: "Value: Low → High" },
  { id: "value_desc", label: "Value: High → Low" },
  { id: "business_order", label: "Business Order" },
];

export const customOrderSortTypes = ["business_order"];

export const numberFormatOptions = [
  { id: "default", label: "Default" },
  { id: "currency", label: "Currency" },
  { id: "percent", label: "Percentage" },
  { id: "scientific", label: "Scientific" },
  { id: "compact", label: "Compact (1K, 1M)" },
];

export const apexChartTypes = {
  BAR: "bar",
  LINE: "line",
  AREA: "area",
  PIE: "pie",
  DONUT: "donut",
  SCATTER: "scatter",
  RADIAL_BAR: "radialBar",
  KPI: "kpi",
  TABLE: "table",
  PIVOT_TABLE: "pivot_table",
  FUNNEL: "funnel",
};

export const apexChartTypeMap = {
  [analyticsCharts.VERTICAL]: apexChartTypes.BAR,
  [analyticsCharts.HORIZONTAL]: apexChartTypes.BAR,
  [analyticsCharts.LINE]: apexChartTypes.LINE,
  [analyticsCharts.AREA]: apexChartTypes.AREA,
  [analyticsCharts.PIE]: apexChartTypes.PIE,
  [analyticsCharts.DONUT]: apexChartTypes.DONUT,
  [analyticsCharts.SCATTER]: apexChartTypes.SCATTER,
  [analyticsCharts.GAUGE]: apexChartTypes.RADIAL_BAR,
  [analyticsCharts.KPI]: apexChartTypes.KPI,
  [analyticsCharts.TABLE]: apexChartTypes.TABLE,
  [analyticsCharts.PIVOT_TABLE]: apexChartTypes.TABLE,
};

export const nonApexChartTypes = [
  analyticsCharts.TABLE,
  analyticsCharts.PIVOT_TABLE,
  analyticsCharts.KPI,
  analyticsCharts.FUNNEL,
];

export const chartFieldConfig = {
  X_AXIS: "x_axis",
  Y_AXIS: "y_axis",
  BREAK_DOWN_BY: "break_down_by",
  COMPARE_BY: "compare_by",
  GROUP_BY: "group_by",
  ROWS: "rows",
  COLUMNS: "columns",
  VALUES: "values",
  VIEW_POINT_DETAIL_BY: "view_point_detail_by",
  VIEW_POINT_SIZE_BY: "view_point_size_by",
  SORT_BY: "sort_by",
  STAGES: "stages",
  FUNNEL_OPTIONS: "funnel_options",
  GAUGE_VALUE: "gauge_value",
  GAUGE_COMPARE_BY: "gauge_compare_by",
};

export const chartFieldConfigDetails = {
  [chartFieldConfig.X_AXIS]: {
    field: chartFieldConfig.X_AXIS,
    label: "X-axis",
    component: "AggregationConfig",
    description:
      "Defines the horizontal axis categories or values. Use dimensions for categorical data or measures for numerical data.",
  },
  [chartFieldConfig.Y_AXIS]: {
    field: chartFieldConfig.Y_AXIS,
    label: "Y-axis",
    component: "AggregationConfig",
    description:
      "Defines the vertical axis values. Typically uses measures to display quantitative data like counts, sums, or averages.",
  },
  [chartFieldConfig.BREAK_DOWN_BY]: {
    field: chartFieldConfig.BREAK_DOWN_BY,
    label: "Break Down by",
    component: "BreakdownConfig",
    description:
      "Splits data into multiple series or segments. Creates separate bars, lines, or slices based on dimension values.",
  },
  [chartFieldConfig.COMPARE_BY]: {
    field: chartFieldConfig.COMPARE_BY,
    label: "Compare by",
    component: null,
    description:
      "Enables time-based comparison. Shows data trends across different time periods like year-over-year or month-over-month.",
  },
  [chartFieldConfig.GROUP_BY]: {
    field: chartFieldConfig.GROUP_BY,
    label: "Group by",
    component: "DimensionConfig",
    description:
      "Organizes data into distinct groups. Useful for creating separate KPI cards or sections based on dimension values.",
  },
  [chartFieldConfig.ROWS]: {
    field: chartFieldConfig.ROWS,
    label: "Rows",
    component: "AggregationConfig",
    description:
      "Defines the row headers in pivot tables. Dimensions placed here will create hierarchical row groupings.",
  },
  [chartFieldConfig.COLUMNS]: {
    field: chartFieldConfig.COLUMNS,
    label: "Columns",
    component: "AggregationConfig",
    description:
      "Defines the column headers. Can be dimensions for pivot tables or any fields for regular tables.",
  },
  [chartFieldConfig.VALUES]: {
    field: chartFieldConfig.VALUES,
    label: "Values",
    component: "AggregationConfig",
    description:
      "Specifies the metrics to display. Shows aggregated numerical data like sum, average, count, min, or max values.",
  },
  [chartFieldConfig.VIEW_POINT_DETAIL_BY]: {
    field: chartFieldConfig.VIEW_POINT_DETAIL_BY,
    label: "View Point detail by",
    component: null,
    description:
      "Adds identifying labels to scatter plot points. Displays dimension values when hovering over or clicking data points.",
  },
  [chartFieldConfig.VIEW_POINT_SIZE_BY]: {
    field: chartFieldConfig.VIEW_POINT_SIZE_BY,
    label: "View Point size by",
    component: null,
    description:
      "Controls the size of scatter plot bubbles. Uses measure values to create bubble charts with varying point sizes.",
  },
  [chartFieldConfig.SORT_BY]: {
    field: chartFieldConfig.SORT_BY,
    label: "Sort by",
    component: "SortByConfig",
    description:
      "Defines the sorting order for table rows. Select a column and sort direction to order data ascending or descending.",
  },
  [chartFieldConfig.STAGES]: {
    field: chartFieldConfig.STAGES,
    label: "Stages",
    component: "StagesConfig",
    description:
      "Define the sequential stages of your funnel. Each stage filters records by a specific field value.",
  },
  [chartFieldConfig.FUNNEL_OPTIONS]: {
    field: chartFieldConfig.FUNNEL_OPTIONS,
    label: "Funnel options",
    component: "FunnelOptionsConfig",
    description:
      "Configure funnel behavior including strict ordering and time-to-convert tracking.",
  },
  [chartFieldConfig.GAUGE_VALUE]: {
    field: chartFieldConfig.GAUGE_VALUE,
    label: "Value",
    component: "AggregationConfig",
    description: "The metric to display in the gauge chart.",
  },
  [chartFieldConfig.GAUGE_COMPARE_BY]: {
    field: chartFieldConfig.GAUGE_COMPARE_BY,
    label: "Compare by",
    component: "DimensionConfig",
    description: "Organizes gauge data into groups for comparison.",
  },
};

export const fieldConfigVisibility = {
  [chartFieldConfig.X_AXIS]: true,
  [chartFieldConfig.Y_AXIS]: true,
  [chartFieldConfig.BREAK_DOWN_BY]: true,
  [chartFieldConfig.COMPARE_BY]: false,
  [chartFieldConfig.GROUP_BY]: true,
  [chartFieldConfig.ROWS]: true,
  [chartFieldConfig.COLUMNS]: true,
  [chartFieldConfig.VALUES]: true,
  [chartFieldConfig.VIEW_POINT_DETAIL_BY]: true,
  [chartFieldConfig.VIEW_POINT_SIZE_BY]: true,
  [chartFieldConfig.SORT_BY]: true,
  [chartFieldConfig.STAGES]: true,
  [chartFieldConfig.FUNNEL_OPTIONS]: true,
  [chartFieldConfig.GAUGE_VALUE]: true,
  [chartFieldConfig.GAUGE_COMPARE_BY]: true,
};

export const fieldsWithHiddenSort = [
  chartFieldConfig.ROWS,
  chartFieldConfig.COLUMNS,
];

export const chartConfigurations = {
  [analyticsCharts.VERTICAL]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.X_AXIS],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.Y_AXIS],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.COMPARE_BY],
      fieldType: chartFieldTypes.DATE,
      multiple: false,
    },
  ],
  [analyticsCharts.HORIZONTAL]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.X_AXIS],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.Y_AXIS],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.COMPARE_BY],
      fieldType: chartFieldTypes.DATE,
      multiple: false,
    },
  ],
  [analyticsCharts.LINE]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.X_AXIS],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.Y_AXIS],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.COMPARE_BY],
      fieldType: chartFieldTypes.DATE,
      multiple: false,
    },
  ],
  [analyticsCharts.SCATTER]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.X_AXIS],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.Y_AXIS],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.VIEW_POINT_DETAIL_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.VIEW_POINT_SIZE_BY],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
  ],
  [analyticsCharts.AREA]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.X_AXIS],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.Y_AXIS],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.COMPARE_BY],
      fieldType: chartFieldTypes.DATE,
      multiple: false,
    },
  ],
  [analyticsCharts.DONUT]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.VALUES],
      fieldType: chartFieldTypes.MEASURE,
      multiple: true,
    },
  ],
  [analyticsCharts.PIE]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.BREAK_DOWN_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.VALUES],
      fieldType: chartFieldTypes.MEASURE,
      multiple: true,
    },
  ],
  [analyticsCharts.KPI]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.GROUP_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.VALUES],
      fieldType: chartFieldTypes.MEASURE,
      multiple: true,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.COMPARE_BY],
      fieldType: chartFieldTypes.DATE,
      multiple: false,
    },
  ],
  [analyticsCharts.TABLE]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.COLUMNS],
      fieldType: null,
      multiple: true,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.SORT_BY],
      fieldType: null,
      multiple: false,
    },
  ],
  [analyticsCharts.GAUGE]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.GAUGE_VALUE],
      fieldType: chartFieldTypes.MEASURE,
      multiple: false,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.GAUGE_COMPARE_BY],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: false,
    },
  ],
  [analyticsCharts.PIVOT_TABLE]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.ROWS],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: true,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.COLUMNS],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: true,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.VALUES],
      fieldType: chartFieldTypes.MEASURE,
      multiple: true,
    },
  ],
  [analyticsCharts.FUNNEL]: [
    {
      ...chartFieldConfigDetails[chartFieldConfig.STAGES],
      fieldType: chartFieldTypes.DIMENSION,
      multiple: true,
    },
    {
      ...chartFieldConfigDetails[chartFieldConfig.FUNNEL_OPTIONS],
      fieldType: null,
      multiple: false,
    },
  ],
};

export const analyticsFilterByTypes = {
  NONE: "none",
  CURRENT_ENTITY: "current_entity",
  CURRENT_SUB_ENTITY: "current_sub_entity",
};

export const analyticsFilterByOptions = [
  { id: analyticsFilterByTypes.NONE, label: "None" },
  {
    id: analyticsFilterByTypes.CURRENT_ENTITY,
    label: "Current entity",
  },
  {
    id: analyticsFilterByTypes.CURRENT_SUB_ENTITY,
    label: "Current entity + Sub entities",
  },
];

export const mainPanelEmptyStates = {
  [analyticsEditorTypes.AI]: {
    text: "Build your own dashboard with SuperAGI",
    description: "Start to chat and build dashboard",
    icon: imageNames.SUPER_AGI_EMPTY_BOLT,
  },
  [analyticsEditorTypes.MANUAL]: {
    text: "Add details to create a dashboard",
    description: "Start to build dashboard",
    icon: imageNames.EMPTY_CHART_PLACEHOLDER,
  },
  NO_DATA: {
    text: "No data found",
    description: "",
    icon: imageNames.EMPTY_CHART_PLACEHOLDER,
  },
};

export const excludedObjectSlugs = ["tasks"];

export const chartValidationRules = {
  [analyticsCharts.VERTICAL]: {
    requiredFields: [chartFieldConfig.X_AXIS, chartFieldConfig.Y_AXIS],
    messages: {
      [chartFieldConfig.X_AXIS]: "X-axis is required",
      [chartFieldConfig.Y_AXIS]: "Y-axis is required",
    },
  },
  [analyticsCharts.HORIZONTAL]: {
    requiredFields: [chartFieldConfig.X_AXIS, chartFieldConfig.Y_AXIS],
    messages: {
      [chartFieldConfig.X_AXIS]: "X-axis is required",
      [chartFieldConfig.Y_AXIS]: "Y-axis is required",
    },
  },
  [analyticsCharts.LINE]: {
    requiredFields: [chartFieldConfig.X_AXIS, chartFieldConfig.Y_AXIS],
    messages: {
      [chartFieldConfig.X_AXIS]: "X-axis is required",
      [chartFieldConfig.Y_AXIS]: "Y-axis is required",
    },
  },
  [analyticsCharts.AREA]: {
    requiredFields: [chartFieldConfig.X_AXIS, chartFieldConfig.Y_AXIS],
    messages: {
      [chartFieldConfig.X_AXIS]: "X-axis is required",
      [chartFieldConfig.Y_AXIS]: "Y-axis is required",
    },
  },
  [analyticsCharts.SCATTER]: {
    requiredFields: [chartFieldConfig.X_AXIS, chartFieldConfig.Y_AXIS],
    messages: {
      [chartFieldConfig.X_AXIS]: "X-axis is required",
      [chartFieldConfig.Y_AXIS]: "Y-axis is required",
    },
  },
  [analyticsCharts.PIE]: {
    requiredFields: [chartFieldConfig.BREAK_DOWN_BY, chartFieldConfig.VALUES],
    messages: {
      [chartFieldConfig.BREAK_DOWN_BY]: "Break down by is required",
      [chartFieldConfig.VALUES]: "At least one value is required",
    },
  },
  [analyticsCharts.DONUT]: {
    requiredFields: [chartFieldConfig.BREAK_DOWN_BY, chartFieldConfig.VALUES],
    messages: {
      [chartFieldConfig.BREAK_DOWN_BY]: "Break down by is required",
      [chartFieldConfig.VALUES]: "At least one value is required",
    },
  },
  [analyticsCharts.KPI]: {
    requiredFields: [chartFieldConfig.VALUES],
    messages: {
      [chartFieldConfig.VALUES]: "At least one value is required",
    },
  },
  [analyticsCharts.TABLE]: {
    requiredFields: [chartFieldConfig.COLUMNS],
    messages: {
      [chartFieldConfig.COLUMNS]: "At least one column is required",
    },
  },
  [analyticsCharts.GAUGE]: {
    requiredFields: [chartFieldConfig.GAUGE_VALUE],
    messages: {
      [chartFieldConfig.GAUGE_VALUE]: "At least one value is required",
    },
  },
  [analyticsCharts.PIVOT_TABLE]: {
    requiredFields: [chartFieldConfig.ROWS, chartFieldConfig.VALUES],
    messages: {
      [chartFieldConfig.ROWS]: "At least one row is required",
      [chartFieldConfig.VALUES]: "At least one value is required",
    },
  },
  [analyticsCharts.FUNNEL]: {
    requiredFields: [chartFieldConfig.STAGES],
    messages: {
      [chartFieldConfig.STAGES]: "At least 2 stages are required",
    },
    minStages: 2,
  },
};

export const funnelStageColors = [
  "#E78453",
  "#2579EF",
  "#48AF7D",
  "#BB58EF",
  "#7095EB",
  "#D89435",
  "#A146E8",
  "#E85D75",
];

export const funnelSummarySections = [
  {
    id: "total_records",
    label: "Total records",
    icon: imageNames.VERTICAL_CHART,
    iconBg: "background: rgba(112, 149, 235, 0.15)",
    iconFilter:
      "filter: invert(55%) sepia(77%) saturate(453%) hue-rotate(186deg) brightness(98%) contrast(87%);",
  },
  {
    id: "overall_conversion",
    label: "Overall conversion",
    icon: imageNames.VERTICAL_CHART,
    iconBg: "background: rgba(72, 175, 125, 0.15)",
    iconFilter:
      "filter: invert(61%) sepia(45%) saturate(487%) hue-rotate(100deg) brightness(92%) contrast(87%);",
  },
  {
    id: "total_drop_off",
    label: "Total drop-off",
    icon: imageNames.VERTICAL_CHART,
    iconBg: "background: rgba(232, 93, 117, 0.15)",
    iconFilter:
      "filter: invert(48%) sepia(76%) saturate(1072%) hue-rotate(318deg) brightness(92%) contrast(89%);",
  },
  {
    id: "avg_time_to_convert",
    label: "Avg. time to convert",
    icon: imageNames.VERTICAL_CHART,
    iconBg: "background: rgba(216, 148, 53, 0.15)",
    iconFilter:
      "filter: invert(66%) sepia(52%) saturate(588%) hue-rotate(4deg) brightness(94%) contrast(87%);",
  },
];
export const paginationDefaults = {
  pageSize: 50,
  position: ["bottomCenter"],
};

export const getTablePaginationConfig = (pagination) => {
  const base = {
    showSizeChanger: false,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
    position: paginationDefaults.position,
  };

  if (!pagination) {
    return { ...base, pageSize: paginationDefaults.pageSize };
  }

  return {
    ...base,
    current: pagination.page,
    pageSize: pagination.page_size,
    total: pagination.total,
  };
};

export const getDataTablePaginationConfig = (pageSize = 10) => ({
  pageSize,
  showSizeChanger: false,
  showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
  position: paginationDefaults.position,
});
export const filterFieldConfig = {
  PROPERTY: "property",
  OPERATOR: "operator",
  VALUE: "value",
};

export const filterValidationMessages = {
  [filterFieldConfig.PROPERTY]: "Property required for filter conditions",
  [filterFieldConfig.OPERATOR]: "Operator required for filter conditions",
  [filterFieldConfig.VALUE]: "Values required for filter conditions",
};

export const externalObjects = { FORMS: "forms" };

export const externalObjectProperties = {
  [externalObjects.FORMS]: [
    {
      id: "id",
      slug: "id",
      label: "Response ID",
      name: "Response ID",
      type: "text",
      fieldName: "id",
      required: false,
      isExternal: true,
    },
  ],
};

export const analyticsBaseColors = [
  "#7095EB",
  "#B343CB",
  "#48AF7D",
  "#D89435",
  "#AC531C",
  "#2579EF",
  "#A146E8",
];

export const chartAxisConfig = {
  [analyticsCharts.VERTICAL]: {
    [chartFieldConfig.X_AXIS]: { showSort: true, showValueSort: true, showAggregation: false, showGrouping: true },
    [chartFieldConfig.Y_AXIS]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.HORIZONTAL]: {
    [chartFieldConfig.X_AXIS]: { showSort: false, showAggregation: true, showGrouping: false },
    [chartFieldConfig.Y_AXIS]: { showSort: true, showValueSort: true, showAggregation: false, showGrouping: true },
  },
  [analyticsCharts.LINE]: {
    [chartFieldConfig.X_AXIS]: { showSort: true, showAggregation: false, showGrouping: true },
    [chartFieldConfig.Y_AXIS]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.AREA]: {
    [chartFieldConfig.X_AXIS]: { showSort: true, showAggregation: false, showGrouping: true },
    [chartFieldConfig.Y_AXIS]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.SCATTER]: {
    [chartFieldConfig.X_AXIS]: { showSort: true, showAggregation: true, showGrouping: false },
    [chartFieldConfig.Y_AXIS]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.KPI]: {
    [chartFieldConfig.GROUP_BY]: { showSort: false, showAggregation: true, showGrouping: false },
    [chartFieldConfig.VALUES]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.PIVOT_TABLE]: {
    [chartFieldConfig.ROWS]: { showSort: true, showAggregation: false, showGrouping: true, allowedSortOptions: ["none", "asc", "desc"], pivotSortByEnabled: true },
    [chartFieldConfig.COLUMNS]: { showSort: true, showAggregation: false, showGrouping: true, allowedSortOptions: ["none", "asc", "desc"], pivotSortByEnabled: true },
    [chartFieldConfig.VALUES]: { showSort: false, showAggregation: true },
  },
  [analyticsCharts.PIE]: {
    [chartFieldConfig.BREAK_DOWN_BY]: { showSort: true, showAggregation: false, showGrouping: false },
    [chartFieldConfig.VALUES]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.DONUT]: {
    [chartFieldConfig.BREAK_DOWN_BY]: { showSort: true, showAggregation: false, showGrouping: false },
    [chartFieldConfig.VALUES]: { showSort: false, showAggregation: true, showGrouping: false },
  },
  [analyticsCharts.TABLE]: {
    [chartFieldConfig.COLUMNS]: { showSort: false, showAggregation: true, showGrouping: false, showNone: true },
  },
};

export const analyticsDefaultDashboardName = "Untitled Dashboard";

export const chartConfigFieldKeys = [
  "x_axis",
  "y_axis",
  "group_by",
  "values",
  "columns",
  "gauge_value",
  "gauge_compare_by",
  "pie_dimension",
  "pie_measure",
  "break_down_by",
];

export const dataTableColumns = [
  { title: "Label", dataIndex: "label", key: "label", width: 200 },
  { title: "Value", dataIndex: "value", key: "value", width: 150 },
];

export const apexDataTabs = [
  { title: "Summarized data" },
  { title: "Unsummarized data" },
];

export const unsummarizedPageSize = 10;
